export default __webpack_public_path__ + "static/blob6-868625dc73b9ef7d87433d9c0e182c94.svg";